import Button from '@/components/ui/button';
import { ptBrCommon } from '@/lib/pt-br/messages';
import { ButtonProps } from '@/types';
import cn from 'classnames';
import { HeaderWalletIcon } from '@/components/icons/header-wallet-icon';
import { useRouter } from 'next/router';
import { Routes } from '@/config/routes';

export default function WalletButton({
  title = 'text-wallet',
  size = 'small',
  className = 'font-semibold',
}: Readonly<Pick<ButtonProps, 'title' | 'size' | 'className'>>) {
const router = useRouter();

  function handleWallet() {
    router.push(Routes.wallet);
  }

  return (
    <Button
      className={cn(
        className,
        'flex flex-col items-center justify-center gap-y-1 h-auto hover:bg-transparent',
      )}
      size={size}
      onClick={handleWallet}
    >
      <HeaderWalletIcon />
      {ptBrCommon(title)}
    </Button>
  );
}
